query GetSunProtectionOrderById($orderId: UUID!, $hubspotDealId: Long!) {
    getSunProtectionOrderById(orderId: $orderId, hubspotDealId: $hubspotDealId) {
        id
        dealId
        createdAt
        updatedAt
        signature {
            id
            url
        }
        discountCode {
            id
            code
            percentage
        }
        products {
            id
            productId
            sunProtectionProductId
            productType
            colorId
            frameColorId
            controlType
        }
    }
}
